(function() {

    var html = `
    <ul>
        <li class="site-nav-more">
            <a href="/epolls/latest_polls/" class="more-menu jQ-section-menu">Polls</a>
            <span class="sections-menu"><img src="/asset/img/grey-chev-sm.png"></span>
            <span class="sections-tab"></span>
            <ul class="primary">
                <li><a class="static" href="/epolls/latest_polls/">Latest Polls</a></li>
                <li><a class="static" href="/epolls/other/president-biden-job-approval-7320.html">Biden Job Approval</a></li>
                <li><a class="static" href="/epolls/other/direction_of_country-902.html">Direction of Country</a></li>
                <li><a class="static" href="/epolls/other/other/FavorabilityRatingsPoliticalLeaders.html">Political Leaders Favorability</a></li>
                <li><a class="static" href="/epolls/other/sotu/PresidentBidenApprovalIssues.html">Biden Approval on Issues</a></li>
                <li><a class="static" href="/epolls/latest_polls/2024/">Election 2024 Polls</a></li>
                <li><a class="static" href="/epolls/other/2024_generic_congressional_vote-7969.html">Generic Congressional Ballot</a></li>
                <li><a class="static" href="/epolls/latest_polls/state_of_the_union/">State of the Union Polls</a></li>
            </ul>
        </li>
        <li class="site-nav-more">
            <a href="/elections/2024/" class="more-menu jQ-section-menu">Election 2024</a>
            <span class="sections-menu"><img src="/asset/img/grey-chev-sm.png"></span>
            <span class="sections-tab"></span>
            <ul class="primary">
                <li><a class="static" href="/epolls/latest_polls/2024/">Latest 2024 Polls</a></li>
                <li><a class="static" href="/epolls/2024/president/us/2024_republican_presidential_nomination-7548.html">Republican Nomination</a></li>
                <li><a class="static" href="/epolls/2024/president/us/2024_democratic_presidential_nomination-7550.html">Democratic Nomination</a></li>
                <li><a class="static" href="/epolls/latest_polls/pres_general/">General Election Polls</a></li>
                <li><a class="static" href="/epolls/2024/president/us/general-election-trump-vs-biden-7383.html">Trump vs. Biden</a></li>
                <li><a class="static" href="/epolls/2024/president/us/general_election_desantis_vs_biden-7967.html">DeSantis vs. Biden</a></li>
                <li><a class="static" href="/epolls/other/2024_generic_congressional_vote-7969.html">Generic Ballot</a></li>
                <li><a class="static" href="/epolls/latest_polls/senate/">Senate Polls</a></li>
                <li><a class="static" href="/epolls/latest_polls/elections/">All Election Polls</a></li>
            </ul>
        </li>
        <li class="" ><a href="/video">Video</a></li>
        <li class="site-nav-more">
            <a href="javascript:void(0);" class="more-menu jQ-section-menu">Writers</a>
            <span class="sections-menu"><img src="/asset/img/grey-chev-sm.png"></span>
            <span class="sections-tab"></span>
            <ul class="primary masthead_staff_menu"></ul>
        </li>
        <li class="site-nav-more">
            <a class="more-menu jQ-section-menu more" href="javascript:void(0);">More</a>
            <img class="jQ-section-menu" src="/asset/img/mobile-menu.png" />
            <span class="sections-menu"><img src="/asset/img/grey-chev-sm.png"></span>
            <span class="sections-tab"></span>
            <ul class="primary">
                <li><a class="static welcome-login" href="/dashboard">Login</a></li>
                <li>
                    <a href="javascript:void(\'0\')">Polls</a>
                    <ul class="inner">
                        <li><a class="static" href="/epolls/latest_polls/">Latest Polls</a></li>
                        <li><a class="static" href="/epolls/other/president-biden-job-approval-7320.html">Biden Job Approval</a></li>
                        <li><a class="static" href="/epolls/other/direction_of_country-902.html">Direction of Country</a></li>
                        <li><a class="static" href="/epolls/other/other/FavorabilityRatingsPoliticalLeaders.html">Political Leaders Favorability</a></li>
                        <li><a class="static" href="/epolls/other/sotu/PresidentBidenApprovalIssues.html">Biden Approval on Issues</a></li>
                        <li><a class="static" href="/epolls/latest_polls/2024/">Election 2024 Polls</a></li>
                        <li><a class="static" href="/epolls/other/2024_generic_congressional_vote-7969.html">Generic Congressional Ballot</a></li>
                        <li><a class="static" href="/epolls/latest_polls/state_of_the_union/">State of the Union Polls</a></li>
                    </ul>
                </li>
                <li>
                    <a href="javascript:void(\'0\')">RCP Election 2024</a>
                    <ul class="inner">
                        <li><a class="static" href="/epolls/latest_polls/2024/">Latest 2024 Polls</a></li>
                        <li><a class="static" href="/epolls/2024/president/us/2024_republican_presidential_nomination-7548.html">Republican Nomination</a></li>
                        <li><a class="static" href="/epolls/2024/president/us/2024_democratic_presidential_nomination-7550.html">Democratic Nomination</a></li>
                        <li><a class="static" href="/epolls/latest_polls/pres_general/">General Election Polls</a></li>
                        <li><a class="static" href="/epolls/2024/president/us/general-election-trump-vs-biden-7383.html">Trump vs. Biden</a></li>
                        <li><a class="static" href="/epolls/2024/president/us/general_election_desantis_vs_biden-7967.html">DeSantis vs. Biden</a></li>
                        <li><a class="static" href="/epolls/other/2024_generic_congressional_vote-7969.html">Generic Ballot</a></li>
                        <li><a class="static" href="/epolls/latest_polls/senate/">Senate Polls</a></li>
                        <li><a class="static" href="/epolls/latest_polls/elections/">All Election Polls</a></li>
                    </ul>
                </li>
                <li><a class="static" href="/video">Video</a></li>
                <li>
                    <a href="javascript:void(\'0\')">Writers</a>
                    <ul class="inner">
                        <ul class="inner masthead_staff_menu"></ul>
                    </ul>
                </li>
                <li><a class="static" href="/articles/">Articles</a></li>
                <li><a class="static" href="/real_clear_opinion_research/">Opinion Research</a></li>
                <li><a class="static" href="/daily_newsletters/">Newsletters</a></li>
                <li><a class="static" href="/podcasts/">Podcasts</a></li>
                <li><a class="static" href="/cartoons/cartoons_of_the_week/">Cartoons</a></li>
                <!--<li><a class="static" href="/timeline/president_donald_trump.html">Trump Timeline</a></li>-->
                <li><a class="static" href="/links/">Links</a></li>
                <li><a class="static" href="/realclearpublishing/">Publishing</a></li>
                <li><a class="static" href="/speakers.html">Speakers</a></li>
                <li><a class="static" href="/contact.html">Contact</a></li>
                <li><a class="static" href="/about.html">About</a></li>
                <li><a class="static" href="/media_kit">Media Kit</a></li>
            </ul>
        </li>
    </ul>
    `;

    // Replace HTML content of all matching targets with above
    var containers = document.querySelectorAll('.masthead_nav');
    if(containers.length > 0) {
        for(var i = 0; i < containers.length; i++) {
            containers[i].innerHTML = html;
        }
    }

    //homepage navigation touch/click handlers
    var homeNavClick = function(e){

        var ele = $(e.target.parentNode);
        var menu = ele.find("ul");
        $( menu ).toggle();
    }

    //smart check for touch events to cover all devices without device/width checks
    $( ".main-nav-bar .masthead_nav ul li a" ).on({
        touchstart: function(e) {
            homeNavClick(e);
        }, touchmove: function(e) {
            homeNavClick(e);
        }
    });

})();